/**
 * 项目基本信息
 */
import { any } from 'prop-types';
import '../../MajorProjectTimeline.less';
import { Collapse, Table } from 'antd';
import { isEmpty } from 'lodash';

const { Panel } = Collapse;
function ProjectBasicInfo({ data }) {
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowKey',
      width: 60,
    },
    {
      title: '区域',
      dataIndex: 'addr',
    },
    {
      title: '种粮地点',
      dataIndex: 'addressCountryside',
      render: (text, record) => (
        <span>
          {text}
          {record.addressVillage}
        </span>
      ),
    },
    {
      title: '承包耕地面积（亩）',
      dataIndex: 'contractedArea',
      width: 100,
    },
    {
      title: '租种耕地面积（亩）',
      dataIndex: 'leasedArea',
      width: 100,
    },
    {
      title: '小麦（亩）',
      dataIndex: 'wheatArea',
      width: 100,
    },
    {
      title: '水稻（亩）',
      dataIndex: 'riceArea',
      width: 100,
    },
    {
      title: '玉米（亩）',
      dataIndex: 'cornArea',
      width: 100,
    },
    {
      title: '马铃薯（亩）',
      dataIndex: 'potatoArea',
      width: 100,
    },
    {
      title: '荞麦（亩）',
      dataIndex: 'buckwheatArea',
      width: 100,
    },
    {
      title: '青稞（亩）',
      dataIndex: 'highlandBarleyArea',
      width: 100,
    },
  ];

  return (
    <div>
      <div className="myapplication-detail__sub-tiny-title">耕种信息</div>
      <Collapse defaultActiveKey={['1']}>
        <Panel key="1" header="耕地面积">
          <div className="myapplication-detail__grid">
            <div>
              总承包耕地面积（亩）：
              {data?.totalContractedArea}
            </div>
            <div>
              总租种耕地面积（亩）：
              {data?.totalLeasedArea}
            </div>
            <div>
              总种植面积（亩）：
              {data?.totalPlantingArea}
            </div>
            <div>
              总补贴面积（亩）：
              {data?.totalSubsidyArea}
            </div>
          </div>
          <div className="myapplication-detail__grid24">
            <div>耕地面积详细情况：</div>
            <div>
              {
                !isEmpty(data?.detailVos)
                && (
                  <Table
                    rowKey="rowKey"
                    columns={columns}
                    dataSource={
                      data?.detailVos.map((item, index) => ({
                        ...item,
                        rowKey: index + 1, // 从 1 开始编号
                      }))
                    }
                    pagination={false}
                    size="small"
                  />
                )
              }
            </div>
          </div>
        </Panel>
      </Collapse>
    </div>
  );
}

export default ProjectBasicInfo;

ProjectBasicInfo.propTypes = {
  data: any,
};
